import React, { useCallback, memo, useRef } from "react";
import './styles/App.css';
import MainMenu from "./components/MainMenu";
import Header from "./components/Header"
import DowntimeAdmin from "./components/DowntimeAdmin";
import SynmonAnalyse from "./components/SynmonAnalyse";
import Popup from 'reactjs-popup';

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { faTwitter, faFontAwesome } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DashboardSystemWithHooks from "./components/Content"
import io from "socket.io-client";  
import { ToastContainer, toast } from 'react-toastify';
import { availableDashboardsAPI } from "./http-common";                                                    // Deconstruct der benötigten API
import AppSpinner from './components/AppSpinner';
import { baseBlade } from './images/blade';
import useLocalStorage from 'use-local-storage'

// Msal imports
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import { InteractionStatus, InteractionType, InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginRequest } from "./authConfig";
import { callMsGraph } from "./utils/MsGraphApiCall";

import 'react-toastify/dist/ReactToastify.css';
import './styles/react-tooltip.css';
import 'reactjs-popup/dist/index.css';

import Dashboards from './DashboardData.js'
// Removed unused import timeseriesAPI
//import { socket } from './socket';
import { setupAPI } from "./http-common";

library.add(fas, far, faTwitter, faFontAwesome)

// MSAL v5 verschlüsselt die im LocalStorage abgelegten Tokens (Schema
// `{ id, nonce, data, lastUpdatedAt }` statt v2 `{ secret, target, ... }`).
// Damit ist das direkte Auslesen des AccessToken aus dem Storage nicht mehr
// möglich – die einzige unterstützte API ist `acquireTokenSilent()`. Da viele
// Aufrufstellen den Token synchron erwarten, cachen wir das letzte Ergebnis
// in einer Modul-Variable. `refreshIDToken()` schreibt den Cache, alle
// `getIDToken()`-Konsumenten lesen ihn.
let cachedAccessToken = "";

 


/***
 *        _   ___ ___   ___ _   _ _  _  ___ _____ ___ ___  _  _ 
 *       /_\ | _ \ _ \ | __| | | | \| |/ __|_   _|_ _/ _ \| \| |
 *      / _ \|  _/  _/ | _|| |_| | .` | (__  | |  | | (_) | .` |
 *     /_/ \_\_| |_|   |_|  \___/|_|\_|\___| |_| |___\___/|_|\_|
 *                                                              
 */

const App = ()=> {
  const defaultDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const [theme, setTheme] = useLocalStorage('theme', defaultDark ? 'dark' : 'light');

  const switchTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
  }

  // Ensure theme attribute also set on <html> and <body> so Portals (outside themeContainer) inherit CSS vars
  React.useEffect(() => {
    if (theme) {
      document.documentElement.setAttribute('data-theme', theme);
      document.body.setAttribute('data-theme', theme);
    }
  }, [theme]);

/***
 *     __  ___      ___  ___  __  
 *    /__`  |   /\   |  |__  /__` 
 *    .__/  |  /~~\  |  |___ .__/ 
 *                                
 */

  const [showWhatsNew, setShowWhatsNew] = React.useState(false)

  const latestWhatsNewDate = 1784937600000;                                                        // Damit neue Whats New Popup erscheinen, muss hier bei jeder Aktualisierung dieser das Datum angepasst werden

  const changeDashboardOverrideID = useRef(0);

  // *************************************************************************************
  // Dashboard handling States
  // *************************************************************************************
  const [availabledashboards, setAvailableDashboards] = React.useState();
  const [shownDashboardID, setShownDashboardID] = React.useState("default");
  const [shownDashboardName, setShownDashboardName] = React.useState("Default Dashboard");
  const [newDashboardName, setNewDashboardName] = React.useState("Default Dashboard");
  const [activeWidgets, setActiveWidgets] = React.useState([
    { i: "productoverview_default", x: 0, y: 0, w: 4, lgw: 6, minW: 4, maxW: 11, h: 25, lgh: 40, minH: 10, maxH: 500, drag: true, resize: true },
    { i: "graphcontainer_default", x: 4, y: 0, w: 18, lgw: 6, minW: 6, maxW: 22, h: 25, lgh: 10, minH: 10, maxH: 500, drag: true, resize: true}
  ]);
  const [dashboardDataAvailable, setDashboardDataAvailable] = React.useState(false);
  const [dashboardFatalError, setDashboardFatalError] = React.useState(false);
  const [dashboardCount, setDashboardCount] = React.useState();
  const [savedWidgetArray, setSavedWidgetArray] = React.useState()
  const [savedOptionsArray, setSavedOptionsArray] = React.useState()

  const [addWidgetType, setAddWidgetType] = React.useState()  
  const [childKey, setChildKey] = React.useState(1);  // State um den grid-layout key zu tracken
  const [unsavedChanges, setUnsavedChanges] = React.useState(false);
  const [firstSyncAfterLoad, setFirstSyncAfterLoad] = React.useState(true);
  const [showSaveModal, setShowSaveModal] = React.useState(false);
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [showUnsafedChangesModal, setShowUnsafedChangesModal] = React.useState(false);  
  const [markedToBeDeleted, setMarkedToBeDeleted] = React.useState({dashboardID: "",dashboardName: ""});
  // *************************************************************************************
  // END Dashboard handling States
  // *************************************************************************************

  const closeWhatsNewWindow = () => {
                                      setShowWhatsNew(false);  
                                      localStorage.setItem("whatsNewDate", latestWhatsNewDate);
                                    }
  const openWhatsNewWindow = () =>  {
                                      setShowWhatsNew(true);  
                                      localStorage.setItem("whatsNewDate", latestWhatsNewDate);
                                    }

  const { instance, inProgress, accounts } = useMsal();
  const [graphData, setGraphData] = React.useState(null);
  const [productData, setProductData] = React.useState();

  const [downtimeAdminVisible, setDowntimeAdminVisible] = React.useState({
    shown: false
  })
  const [synmonAnalyseVisible, setSynmonAnalyseVisible] = React.useState({
    shown: false,
    data: {}
  })  
  // Removed unused states: errorDetailsVisible, timeseries
  const [visibleGraphs, setVisibleGraphs]  = React.useState([]);
  const [replaceGraph, setReplaceGraph] = React.useState(false)                                // Indikator ob die Graphen immer weiter zum Widget hinzugefügt werden oder die vorhandenen ersetzen
  const [graphDefaultTimerange, setGraphDefaultTimerange] = React.useState("6h") 
  // Removed unused states: showPrioFlags, showDeploymentFlags


  // State um Windows resize Event zu detecten
  // Removed unused state windowResizing

  // State für die Sichtbarkeit des Hauptmenüs
  const [mainMenuStatus, setMainMenuStatus] = React.useState({
      shown: false
  })

   
  /**
   * Liefert den zuletzt via `acquireTokenSilent()` geholten AccessToken aus
   * dem Modul-Cache. Wird benötigt, weil zahlreiche Aufrufstellen (axios-
   * Header, Socket-Auth) den Token synchron erwarten, MSAL v5 aber nur eine
   * asynchrone API anbietet. Vor der ersten Verwendung muss
   * `refreshIDToken()` mindestens einmal gelaufen sein – das passiert beim
   * App-Start im MS-Graph-`useEffect` (await), die Socket-Schleife heilt
   * sich über den `connect_error`-Handler selbst.
   */
  const getIDToken = useCallback(() => {
    return cachedAccessToken;
  }, [])

  
  /** 
   * ID Token refresh
   */
  const refreshIDToken = useCallback(async () => {
    let accessToken;
    const accessTokenRequest = {
      scopes: ["api://ac67ef6f-69d9-4ad1-9c6c-5a54d02bac02/e2e.all"],
      account: accounts[0],
    };
    try {
      const accessTokenResponse = await instance.acquireTokenSilent(accessTokenRequest);
      accessToken = accessTokenResponse.accessToken;
      cachedAccessToken = accessToken;
    } catch (error) {
      console.error("Token refresh failed:", error?.errorCode, error?.message);
    }
    return accessToken;
  }, [accounts, instance]);


  // State für dynamische Infos im Seiten Header
  const [headerData, setHeaderData] = React.useState(() => {
    
    let timestamp = new Date();
    timestamp = timestamp.toLocaleString('de-DE');
    let statusText = "Letzte Aktualisierung: " + timestamp;

    return {
      title: "Zentrales Monitoring Dashboard",
      description: statusText,
      username: "Maximilian Mustermann"
    }
  })

  // State für die verfügbaren Dashboards
  const [dashboardData] = React.useState(Dashboards); // setter unused



  /***********************************************************************************************************
  /********************************************* DATENABRUF **************************************************
  /********************************************************************************************************** */  

/**
 * Bei jedem erstaufruf des Dashboards den User im Backend melden um ggf. den User in der DB anzulegen
 * @param {*} userObject MS Graph API response
 */
const setupUser = useCallback(async (userObject) => {
  //console.log(userObject)
  const idToken = getIDToken();
  const headers = { 'Authorization': idToken };
  try {
    await setupAPI.post('', userObject, {headers});
    //console.log("User Setup ran!");
    return "ok";
  } catch (error) {
    console.log("Fetch error while user setup" + error);
    setDashboardFatalError(true);
    let obj = [];
    return obj;
  }
}, [getIDToken]);


/**
 * Alle für den User verfügbaren Dashboards abrufen
 * @param {*} userID MS Graph API
 */
const fetchDashboards = useCallback(async (userID) => {  

  const idToken = getIDToken();
  const headers = { 'Authorization': idToken };
  await availableDashboardsAPI.get("?userId=" + userID, {headers})
  .then(response => {

    let obj = response.data;
    setAvailableDashboards(obj)

    //console.log("Available dashboards:")
    //console.log(obj)    

    const activeDashboardIndex = response.data.findIndex((dashboard) => dashboard.active === true);    

    if(activeDashboardIndex !== -1){
      /*
      console.log("Active Dashboard Index: " + activeDashboardIndex)
      console.log("Active Dashboard ID: " + obj[activeDashboardIndex]["_id"])
      console.log("Active Dashboard Widgets: ")
      console.log(obj[activeDashboardIndex]["widgets"])
      */

      setShownDashboardID(obj[activeDashboardIndex]["_id"])
      setActiveWidgets(obj[activeDashboardIndex]["widgets"])
      setDashboardCount(obj[activeDashboardIndex]["count"])
      setShownDashboardName(obj[activeDashboardIndex]["name"])
      setSavedOptionsArray(obj[activeDashboardIndex].options)

      // BUGFIX (Options-Waisen): Nur Options-Einträge berücksichtigen, die
      // tatsächlich ein zugehöriges Widget haben. Alt-„Leichen" (z.B.
      // graphcontainer_default in Dashboards mit ausschließlich zufällig
      // benannten Widgets) würden sonst im forEach den letzten
      // setVisibleGraphs-Call überschreiben und beim nächsten Save-Restore
      // die falschen Graphen anzeigen. Siehe App.jsx onRemoveItem/
      // removeFromOptions für die Wurzelbeseitigung.
      const activeWidgetIds = new Set(
        (obj[activeDashboardIndex].widgets || []).map(w => w.i)
      );

      obj[activeDashboardIndex].options.forEach(function (arrayItem) {
        
        if(arrayItem.i !== undefined && activeWidgetIds.has(arrayItem.i)){
          let string = arrayItem.i
          let subBefore= string.substring(0, string.indexOf('_'));
          if(subBefore === "graphcontainer"){
            setGraphDefaultTimerange(arrayItem.graphDefaultTimerange)
            setVisibleGraphs(arrayItem.visibleGraphOptions)
            setReplaceGraph(arrayItem.replaceGraphOption)
          }
        }
      });
      
      setDashboardDataAvailable(true)
    } else {
      setDashboardCount(0)
      setSavedOptionsArray([])
      setDashboardDataAvailable(true)
    }
    
    return obj

  })
  .catch(function (error) {
    console.log("Fetch error available Dashboards" + error)
    setDashboardFatalError(true);
    let obj = [];
    setTimeout(() => {
      console.log("Erneutes Aufrufen der Dashboard API wird versucht")
      setDashboardFatalError(false)
      fetchDashboards(userID);
    }, 2000);
    return (obj)
  });

}, [getIDToken]);  




  /***
   *          ___  __   __   __   __        ___ ___                    __               __  
   *    |  | |__  |__) /__` /  \ /  ` |__/ |__   |     |__|  /\  |\ | |  \ |    | |\ | / _` 
   *    |/\| |___ |__) .__/ \__/ \__, |  \ |___  |     |  | /~~\ | \| |__/ |___ | | \| \__> 
   *                                                                                        
   */
 
  
  /*
  const idToken = getIDToken();


  const socket = io(process.env.REACT_APP_BACKEND_SVC, {
    path: "/ts/socket.io",
    auth: {
      token: idToken
    }
  }); 
 */

  //Room State
  //const [room, setRoom] = React.useState("");
  //const [isConnected, setIsConnected] = React.useState(socket.connected);
  //const [lastPong, setLastPong] = React.useState(null);

  // Messages States
  //const [message, setMessage] = React.useState("");
  //const [messageReceived, setMessageReceived] = React.useState("");

  /*
  const joinRoom = () => {
    if (room !== "") {
      socket.emit("join_room", room);
      console.log("joined: " + room)
    }
  };

  const sendMessage = () => {
    socket.emit("send_message", { message, room });
    console.log("send!")
  };
  */
  
  // Removed unused connection state (UI not consuming isConnected)

  React.useEffect(() => {

    // Beim allerersten Render ist der Token-Cache noch leer (MSAL v5 liefert
    // nur asynchron via acquireTokenSilent). Außerdem braucht es einen
    // bekannten Account, sonst kann acquireTokenSilent nichts holen. Zudem
    // muss `inProgress === None` sein – während HandleRedirect/Login/etc.
    // ist der MSAL-Token-Cache noch nicht final und acquireTokenSilent
    // kann einen ungültigen Token liefern (Symptom: WebSocket-Connect
    // schlägt mit "invalid token" fehl, geht erst nach manuellem Reload).
    if (inProgress !== InteractionStatus.None) {
      return;
    }
    if (!accounts || accounts.length === 0) {
      return;
    }

    let socket;
    let cancelled = false;

    refreshIDToken().then((token) => {
      if (cancelled) return;

      socket = io(process.env.REACT_APP_BACKEND_SVC, {
        path: "/ts/socket.io",
        auth: {
          token: token
        }
      });

      socket.on('connect', () => {
        // connection established (ignored)
      });

      socket.on('disconnect', () => {
        // connection lost (ignored)
      });

      socket.on('productData', (data) => {
        //console.log(data.message);
        refreshIDToken().then((newToken) => {
          socket.auth.token = newToken;
        });

        let timestamp = new Date();
        timestamp = timestamp.toLocaleString('de-DE');
        let statusText = "Letzte Aktualisierung: " + timestamp;

        setHeaderData(prevStatus => ({
          ...prevStatus,
          description: statusText
        }))

        setProductData(data.message)
        // productDataIsLoaded flag removed (was unused)
      });

      socket.on("connect_error", (data) => {

        const errormessage = data.message

        if (errormessage === "invalid token") {
          console.log("Der Token wurde vom Websocket abgelehnt und scheint ungültig zu sein. Versuche Token refresh...")
          refreshIDToken().then((newToken) => {
            socket.auth.token = newToken;
            setTimeout(() => {
              socket.connect();
            }, 1000);
          });
        } else {
          console.log("Ran into an error while gathering websocket Data!")
          //notify({type: 'alert', message: 'Es können keine Produktübersicht Daten empfangen werden!Wir versuchen es in Kürze erneut.'})
          setTimeout(() => {
            socket.connect();
          }, 10000);
        }

      });
    });

    return () => {
      cancelled = true;
      if (socket) {
        socket.off('connect');
        socket.off('disconnect');
        socket.off('productData');
        socket.disconnect();
      }
    };

  }, [accounts, inProgress, getIDToken, refreshIDToken]);



  /***
   *          __   ___     ___  ___  ___  ___  __  ___  __  
   *    |  | /__` |__     |__  |__  |__  |__  /  `  |  /__` 
   *    \__/ .__/ |___    |___ |    |    |___ \__,  |  .__/ 
   *                                                        
   */

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // Abruf der Azure AD Graph Daten
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  React.useEffect(() => {

    if (!graphData && inProgress === InteractionStatus.None) {
        callMsGraph()
        .then(async response =>
          {
            // Token MUSS hier awaitet werden: setupUser und fetchDashboards
            // lesen `cachedAccessToken` synchron über `getIDToken()`.
            // Ohne await würden beide mit leerem Header laufen → 401.
            await refreshIDToken();

            setupUser(response).then(() => {
              setGraphData(response);
              fetchDashboards(response.id);
            })

          })

        .catch((e) => {
            if (e instanceof InteractionRequiredAuthError) {
                instance.acquireTokenRedirect({
                    ...loginRequest,
                    account: instance.getActiveAccount()
                });
            }
        });
    }

  }, [inProgress, graphData, instance, refreshIDToken, setupUser, fetchDashboards]);

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // Prüfen und Anzeigen der Whats New Info
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  React.useEffect(() => {
    const whatsNewDate = JSON.parse(localStorage.getItem('whatsNewDate')) 
    
    if(whatsNewDate !== undefined){

        if(whatsNewDate !== latestWhatsNewDate){
          localStorage.setItem("whatsNewDate", latestWhatsNewDate);
          setShowWhatsNew(true)
        } else {
          setShowWhatsNew(false)
        }

    } else {
        localStorage.setItem("whatsNewDate", latestWhatsNewDate);
        setShowWhatsNew(true)
    }

  }, []);  
  




  /*
  React.useEffect(() => {
    let timeout;
    const handleResize = () => {
      clearTimeout(timeout);
      setWindowResizing(true);

      timeout = setTimeout(() => {
        setWindowResizing(false);
       
        //notify({type: 'info', message: 'Resize event has ended!'})

        // grid Layout key verändern. Dies forced den component unmount und triggert somit ein resize der einzelnen Widgets
        setChildKey(prev => prev + 1);
        
      }, 200);
    }
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  */

  /***
   *     ___            __  ___    __        __  
   *    |__  |  | |\ | /  `  |  | /  \ |\ | /__` 
   *    |    \__/ | \| \__,  |  | \__/ | \| .__/ 
   *                                             
   */




  /**
   * Alert Box Handling
   * Bereitstellung von Alert Boxen die mit den Parametern 'type' und 'message' befüllt werden können
   * @param {*} param 
   */   

  const notify = useCallback((param) => {

    const notifyInfo = (message) => toast.info(message, {
      position: "bottom-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });

    const notifyInfoPerm = (message) => toast.success(message, {
      position: "bottom-right",
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: "dark",
    });

    const notifySuccess = (message) => toast.success(message, {
      position: "bottom-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    }); 
    
    const notifyError = (message) => toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    }); 

    const notifyErrorLong = (message) => toast.error(message, {
      position: "bottom-right",
      autoClose: 50000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });     

    const notifyWarn = (message) => toast.warn(message, {
      position: "bottom-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });    

    switch (param.type) {
      case 'alert':
        notifyError(param.message)
        break;
      case 'alertLong':
          notifyErrorLong(param.message)
          break;        
      case 'warning':
        notifyWarn(param.message)
        break;
      case 'success':
        notifySuccess(param.message)
      break; 
      case 'infoPerm':
        notifyInfoPerm(param.message)
      break;              
      default:
        notifyInfo(param.message)
    }
  }, [])

  const toggleMainMenuStatus = useCallback((setTo) => {
    //console.log("Main menu") 
    setMainMenuStatus(prevStatus => ({
      ...prevStatus,
      shown: setTo
    }))
  }, [])


  const toggleDowntime = useCallback(() => {
    let setTo = downtimeAdminVisible.shown;
    console.log("DowntimeVisible: " + setTo)
    if(downtimeAdminVisible.shown === true){
      setTo = false;
      console.log("Set to False")
    }else{
      setTo=true;
      console.log("Set to True")

    }
    console.log(setTo)

    setDowntimeAdminVisible(prevStatus => ({
      ...prevStatus,
      shown: setTo
    }))
  }, [downtimeAdminVisible])



  const toggleSynmonAnalyse = useCallback((param) => {
    
    let setTo = synmonAnalyseVisible.shown;
    console.log("SynmonAnalyseVisible: " + setTo)
    if(synmonAnalyseVisible.shown === true){
      setTo = false;
      console.log("Set to False")
    }else{
      setTo=true;
      console.log("Set to True")

    }
    console.log(setTo)

    setSynmonAnalyseVisible(prevStatus => ({
      ...prevStatus,
      shown: setTo,
      data: param
    }))
  }, [synmonAnalyseVisible])  

  

    /***********************************************************************************************************
    /******************************************* GRAPH HANDLING START ******************************************
    /***********************************************************************************************************
     /**
     * Löschen eines Graphen
     * @param {*} key Erwartet ID des Graphen
     */
     const deleteSingleGraph = useCallback((key) => {
      console.log("Delete: " + key)

      setVisibleGraphs(oldValues => {
        return oldValues.filter(obj => obj.testID !== key)
      })
    }, [])

     /**
     * Löschen aller Graphen
     * @param {*} key Erwartet ID des Graphen
     */
     const deleteAllGraph = useCallback(() => {
      console.log("Delete all Graphs")
      setVisibleGraphs([])
    }, [])

    /**
     * Hinzufügen aller Tests eines Produktes zum Graph container, gefiltert nach origin.
     * @param {string} originFilter - z. B. "synthetic" oder "AWS": nur Tests dieses Origins werden geöffnet.
     * @param {*} product - Produkt-ID
     */
    const addAllGraphs = (originFilter, product) => {
      const productIndex = productData.findIndex((searchedItem) => searchedItem._id === product);
      if(replaceGraph === true){
        deleteAllGraph();
      }
      productData[productIndex].tests.forEach(function(testElement) {
        if(testElement.origin === originFilter){
          addGraph(testElement._id, productData[productIndex]._id, testElement.displayName, productData[productIndex].displayName, 'all', testElement.origin)
        }
      })
    }

    /**
     * Hinzufügen eines Graphen zum Graph Container
     */
    const addGraph = (test, product, displayName, productName, type, origin) => {

        const checkIfAlreadyExist = savedWidgetArray.find(e => e.type === 'graphcontainer');
        
        if(checkIfAlreadyExist === undefined){
          addNewWidget('graphcontainer', true)
        } 

        const productIndex = productData.findIndex((searchedProduct) => searchedProduct._id === product);
        const productTestIndex = productData[productIndex].tests.findIndex((searchedTest) => searchedTest._id === test);
        const visibleGraphsIndex = visibleGraphs.findIndex((searchedItem) => searchedItem.testID === test);
      
        if(replaceGraph === true && type !== 'all'){
          deleteAllGraph();
        }

        if(visibleGraphsIndex === -1 || replaceGraph === true){
          const newGraph = {
            testID: test,
            productID: product,
            displayName: displayName,
            productName: productName,
            origin: origin ?? productData[productIndex].tests[productTestIndex].origin,
            url: productData[productIndex].tests[productTestIndex].url,
            thresholds: productData[productIndex].tests[productTestIndex].thresholds,
            avgDuration: productData[productIndex].tests[productTestIndex].avgDuration,
            countOk: productData[productIndex].tests[productTestIndex].countOk,
            owner: productData[productIndex].tests[productTestIndex].owner
          };
  
          setVisibleGraphs(prev => [
            ...prev,
            newGraph
          ])
  
        } else {
          console.log("Graph is already visible")
          notify({type: 'info', message: 'Dieser Graph wird bereits dargestellt.'})
        }        
    }


    const changeGraphOptions = (options) => {
      setReplaceGraph(options.replaceGraph)
      setGraphDefaultTimerange(options.timerange)
      syncOptionsArray("graphcontainer_default", options)
    }

    
  /***********************************************************************************************************
  /********************************************* GRAPH HANDLING END ******************************************
  /********************************************************************************************************** */

  const addNewWidget = (widgetType, fromGraph) => {
    console.log("Add: " + widgetType)
    let checkIfAlreadyExist = null

    if(savedWidgetArray !== undefined){
      savedWidgetArray.forEach(function(item) {

        let string = item.i
        let stringBefore= string.substring(0, string.indexOf('_'));  
        if(stringBefore === widgetType){
          checkIfAlreadyExist = true
        }      

      })
    }
    
    if(checkIfAlreadyExist === true){
      console.log("Widget wurde bereits gefunden")
      if(fromGraph !== true){
        notify({type: 'info', message: 'Dieses Widget befindet sich bereits im Dashboard.'})
      }
    } else {
      setAddWidgetType(widgetType)
    }
    
  }

    /**
     * Funktion welche einen Link in einem neuen Tab oeffnet
     * Der Link, welcher geoeffnet werden soll wird mitgegeben
     * @param {*} link 
     */
    const openLink = (link) => {
      window.open(link,"_blank");
  }


  
  /***********************************************************************************************************
  /********************************************* DASHBOARD HANDLING ******************************************
  /********************************************************************************************************** */
  const changeShownDashboardOverride = () => {       
      changeShownDashboard(changeDashboardOverrideID.current, true);    
  }
  
  const changeShownDashboard = (dashboardID, ignoreCheck) => {
    if(unsavedChanges === true && ignoreCheck !== true){
      changeDashboardOverrideID.current = dashboardID;
      setShowUnsafedChangesModal(true);
    } else {
      setVisibleGraphs([])
      setAddWidgetType(null)
      setShowUnsafedChangesModal(false)
      setDashboardDataAvailable(false)    
      setUnsavedChanges(false);
      setFirstSyncAfterLoad(true);
      
      const activeDashboardIndex = availabledashboards.findIndex((dashboard) => dashboard._id === dashboardID);
  
      //console.log("av Dash")
      //console.log(availabledashboards[activeDashboardIndex])

      if(activeDashboardIndex !== -1){
        setShownDashboardID(availabledashboards[activeDashboardIndex]["_id"])
        setShownDashboardName(availabledashboards[activeDashboardIndex]["name"])
        setNewDashboardName(availabledashboards[activeDashboardIndex]["name"])
        setActiveWidgets(availabledashboards[activeDashboardIndex]["widgets"])
        setDashboardCount(availabledashboards[activeDashboardIndex]["count"])
        setSavedOptionsArray(availabledashboards[activeDashboardIndex].options)

          // BUGFIX (Options-Waisen): siehe Kommentar im ersten Load-Handler weiter oben.
          const activeWidgetIdsDW = new Set(
            (availabledashboards[activeDashboardIndex].widgets || []).map(w => w.i)
          );
  
          availabledashboards[activeDashboardIndex].options.forEach(function (arrayItem) {
            
            if(arrayItem.i !== undefined && activeWidgetIdsDW.has(arrayItem.i)){
              let string = arrayItem.i
              let subBefore= string.substring(0, string.indexOf('_'));
              
              if(subBefore === "graphcontainer"){
                //console.log(arrayItem)
                console.log("called!!!")
                setGraphDefaultTimerange(arrayItem.graphDefaultTimerange)
                setVisibleGraphs(arrayItem.visibleGraphOptions)
                setReplaceGraph(arrayItem.replaceGraphOption)
              }
            }
          });      
  
        setDashboardDataAvailable(true)
        setChildKey(prev => prev + 1)
        sendActiveDashboard(dashboardID)
      } else {
        setShownDashboardID(availabledashboards[activeDashboardIndex]["default"])
        setShownDashboardName(availabledashboards[activeDashboardIndex]["Default Dashboard"])
        setNewDashboardName(availabledashboards[activeDashboardIndex]["Default Dashboard"])
        setActiveWidgets([
          { i: "productoverview_default", x: 0, y: 0, w: 4, lgw: 6, minW: 4, maxW: 11, h: 25, lgh: 40, minH: 10, maxH: 500, drag: true, resize: true },
          { i: "graphcontainer_default", x: 4, y: 0, w: 18, lgw: 6, minW: 6, maxW: 22, h: 25, lgh: 10, minH: 10, maxH: 500, drag: true, resize: true}
        ])
        setDashboardCount(0)
        setDashboardDataAvailable(true)
        setChildKey(prev => prev + 1)
      }            
    }
  }



  const syncVisibleWidgets = (items)=> {
    if(savedWidgetArray !== items){
      setSavedWidgetArray(items)
      
      if(firstSyncAfterLoad === false){
        setUnsavedChanges(true);      
      } else {
        setFirstSyncAfterLoad(false)
      }
      
    } else {
      console.log("No changes found!")
    }

  }

  /**
   * Funktion um das Options Element beim Entfernen eines Widgets anzupassen.
   *
   * BUGFIX (Wurzel): Früher wurde `productoverview_default` von der Löschung
   * ausgenommen. Das führte zu Options-Waisen im gespeicherten Dashboard
   * (Options-Eintrag ohne zugehöriges Widget), die beim Load im forEach den
   * letzten setVisibleGraphs-Call überschrieben. Wir entfernen jetzt konsequent
   * ALLE Widget-Options bei einem Widget-Remove.
   */
  const removeFromOptions = (widgetID) => {
    console.log(widgetID)
    setSavedOptionsArray(oldValues => {
      return oldValues.filter(obj => obj.i !== widgetID)
    })
  }

  /**
   * Funktion um die vom user gemachten Änderungen an den Optionen zu synchronisieren
   * @param {*} widgetID  ID des Widgets, welches das Optionen Objekt an die Funtkion schickt 
   * @param {*} options Optionen Object eines Widgets
   */
  const syncOptionsArray = (widgetID, options)=> {

    //console.log("Sync called for: " + widgetID)
    //console.log("With options: ")
    //console.log(options)

    const optionIndex = savedOptionsArray.findIndex((widget) => widget.i === widgetID);
    let sendOptions = options;
    let string = widgetID
    let subBefore= string.substring(0, string.indexOf('_'));

    if(subBefore === "graphcontainer"){
        //console.log("Should be in graphcontainer now" + options)
        sendOptions = {
            i: widgetID,
            graphDefaultTimerange: options.timerange,
            replaceGraphOption: options.replaceGraph, 
            visibleGraphOptions: visibleGraphs
        };
    } 

  if(JSON.stringify(savedOptionsArray[optionIndex]) !== JSON.stringify(sendOptions)){

      //console.log("Saved Options:");
      //console.log(savedOptionsArray[optionIndex]);
      //console.log("Send Options:");
      //console.log(sendOptions);

      let tempArray = [...savedOptionsArray];  
      const index = tempArray.findIndex((element) => element.i === widgetID);
      tempArray[index] = sendOptions;

      if(index !== -1){
        if(subBefore === "productoverview"){
          tempArray[index].visibleTests.forEach(function (arrayItem) {
            arrayItem.tests = []
          });
          setSavedOptionsArray(tempArray);

        } else {
          setSavedOptionsArray(tempArray);
        }
      } else {
        if(subBefore === "graphcontainer" || subBefore === "productstatus" ){
          console.log("Found options for: " + subBefore)
          setSavedOptionsArray(current => [...current, sendOptions]);   // bei neu angelegten Widgets wird hier das zugehörige Options Objekt einfach hinzugefügt
        } else {
          setSavedOptionsArray(current => [...current, options]);       // bei neu angelegten Widgets wird hier das zugehörige Options Objekt einfach hinzugefügt
        }
      }
      

      if(firstSyncAfterLoad === false){
        setUnsavedChanges(true);      
      } else {
        setFirstSyncAfterLoad(false)
      }

    } else {
      console.log("No Option changes found!")
    }

  }

 
  const checkBeforeSaveDashboard = () => {
    setNewDashboardName(shownDashboardName)
    setShowSaveModal(true)
  }

  /**
   * Speichern des Dashboards
   */
  const saveDashboard = () => {
    if (newDashboardName !== "Default Dashboard") {
      console.log("Save Dashboard Options: ")
      console.log(savedOptionsArray)

      // BUGFIX (Options-Waisen aus Backend räumen):
      // Options-Einträge ohne zugehöriges Widget aus dem PUT/POST-Payload
      // filtern. Dadurch werden bereits existierende Alt-Leichen bei jedem
      // Save automatisch aus dem Backend entfernt — kein manueller DB-Fix nötig.
      const activeWidgetIdsForSave = new Set(
        (savedWidgetArray || []).map(w => w.i)
      );
      const cleanOptions = (savedOptionsArray || []).filter(opt =>
        !opt || opt.i === undefined || activeWidgetIdsForSave.has(opt.i)
      );

      // JSON für das gesamte Dashboard erstellen
      const dashboardData = JSON.stringify({
        widgets: savedWidgetArray,
        options: cleanOptions,
        active: true,
        userId: graphData.id,
        name: newDashboardName,
        count: dashboardCount,
      });

      if (shownDashboardName === newDashboardName) {
        console.log("Dashboard Namen sind gleich = PUT!");

        const idToken = getIDToken();
        const headers = { 'Authorization': idToken };

        availableDashboardsAPI
          .put("/" + shownDashboardID, dashboardData, {headers})
          .then((response) => {
            console.log(response);
            notify({ type: "success", message: "Speichern abgeschlossen" });
            refreshAvailableDashboards(graphData.id); // Die availableDashboards mit den soeben gespeicherten Daten refreshen
            setUnsavedChanges(false);
            setShowSaveModal(false);
          })
          .catch((response) => {
            console.log(response);
            setShowSaveModal(false);
            notify({ type: "alert", message: "Speichern fehlgeschlagen" });
          });
      } else {
        //console.log("Dashboard Namen sind NICHT gleich = POST!");
        const idToken = getIDToken();
        const headers = { 'Authorization': idToken };

        availableDashboardsAPI
          .post("/", dashboardData, {headers})
          .then((response) => {
            //console.log(response);
            notify({ type: "success", message: "Speichern abgeschlossen" });
            refreshAvailableDashboards(graphData.id); // Die availableDashboards mit den soeben gespeicherten Daten refreshen
            setUnsavedChanges(false);
            setShowSaveModal(false);
          })
          .catch((response) => {
            console.log(response);
            setShowSaveModal(false);
            notify({ type: "alert", message: "Speichern fehlgeschlagen" });
          });
      }

    } else {
      notify({ type: "alert", message: "Es muss ein anderer Dashboard Name gewählt werden! Das Default Dashboard kann nicht überschrieben werden." });
    }
  };
    

  /**
   * Modal Abfrage bevor das Dashboard gelöscht wird. 
   */
  const checkBeforeDashboardDelete = (dashboardID, dashboardName) => {
    
    const dashboardObj = {
      dashboardID: dashboardID,
      dashboardName: dashboardName
    }
    setMarkedToBeDeleted(dashboardObj)
    setShowDeleteModal(true)
  }

  /**
   * Löschen eines Dashboards anhand seiner ID
   */
  const deleteDashboard = () => {

    const idToken = getIDToken();
    const headers = { 'Authorization': idToken };

    availableDashboardsAPI
    .delete("/" + markedToBeDeleted.dashboardID + "?userId=" + graphData.id, {headers})
    .then((response) => {
      //console.log(response);
      notify({ type: "success", message: "Das Dashboard: " + markedToBeDeleted.dashboardName + " wurde gelöscht!"});
      refreshAvailableDashboards(graphData.id); // Die availableDashboards mit den soeben gespeicherten Daten refreshen
      setShowDeleteModal(false);

      if(markedToBeDeleted.dashboardID === shownDashboardID){
        window.location.reload();
      }

    })
    .catch((response) => {
      console.log(response);
      setShowDeleteModal(false);
      notify({ type: "alert", message: "Löschen fehlgeschlagen" });
    });
  }

  /**
   * Ein Dashboard als das für den User aktive setzen. Dies hat zur Folge das beim nächsten Aufruf der Seite dieses Dashboard geladen wird. 
   */
  const sendActiveDashboard = (dashboardID) => {
    //console.log("Set active Dashboard for user: " + graphData.id + " to DashboardID: " + dashboardID)
    const idToken = getIDToken();
    const headers = { 'Authorization': idToken };

    availableDashboardsAPI
    .get("/" + dashboardID + "/setActive?userId=" + graphData.id, {headers})
    .then((response) => {
      //console.log(response);
      refreshAvailableDashboards(graphData.id); // Die availableDashboards mit den soeben gespeicherten Daten refreshen
    })
    .catch((response) => {
      //console.log(response);
    });    
  }

  /**
   * Nach dem Speichern müss das Hauptmenü sowie der availableDashboard State geupdated werden
   * @param {*} userID 
   */
  const refreshAvailableDashboards = async (userID) => {  
    const idToken = getIDToken();
    const headers = { 'Authorization': idToken };

    await availableDashboardsAPI.get("?userId=" + userID, {headers})
    .then(response => {
      let obj = response.data;

      const activeDashboardIndex = obj.findIndex((setActive) => setActive.active === true);

      if(activeDashboardIndex !== -1){
        setAvailableDashboards(obj)
      } else {
        const defaultDashboardIndex = obj.findIndex((dashboard) => dashboard.name === "Default Dashboard");
        sendActiveDashboard(obj[defaultDashboardIndex]._id)
      }
      
    })
    .catch(function (error) {
      console.log("Error on refresh available Dashboards" + error)
    });    
  }  

  /**
   * Event handler der bei Eingabe eines Dashboard Namens die zugehörigen States anpasst
   * @param {*} event 
   */
  const handleNewDashboardName = (event) => {
    if(event.target.value === ""){
      setNewDashboardName(shownDashboardName)
    } else {
      setNewDashboardName(event.target.value)
    }      
  }




 
  /***
   *     __   __            __   ___ ___       __       
   *    |  \ /  \  |\/|    |__) |__   |  |  | |__) |\ | 
   *    |__/ \__/  |  |    |  \ |___  |  \__/ |  \ | \| 
   *                                                    
   */

  return (
    
    <div className="themeContainer" data-theme={theme}>
      <>
  {/* Suppress React warning about unknown isLoading prop on internal toast icon by disabling default icons. */}
  <ToastContainer icon={false} />
      <Popup open={showWhatsNew} closeOnDocumentClick onClose={closeWhatsNewWindow}>
        <div className="whatsNewPopup">
          <div className="whatsNewPopup--Header">
            <div className="whatsNewPopup--IconWrap" aria-hidden="true">
              <FontAwesomeIcon icon="fa-solid fa-hand" />
            </div>
            <div className="whatsNewPopup--TitleWrap">
              <h2 className="whatsNewPopup--Title">Willkommen im Zentralen Monitoring Dashboard</h2>
              <p className="whatsNewPopup--Subtitle">Statusüberblick über Freenet-Systeme</p>
            </div>
            <button
              type="button"
              className="whatsNewPopup--CloseBtn"
              onClick={() => closeWhatsNewWindow()}
              aria-label="Schließen"
              title="Schließen"
            >
              <FontAwesomeIcon icon="fa-solid fa-xmark" />
            </button>
          </div>

          <div className="whatsNewPopup--Body">
            <p className="whatsNewPopup--Intro">
              Willkommen im zentralen Monitoring Dashboard der Freenet. Hier findest du den
              Ausgangspunkt in verschiedene Monitorings der Infrastruktur und erhältst einen
              Statusüberblick über diverse Systeme.
            </p>

            <div className="whatsNewPopup--Release">
              <div className="whatsNewPopup--ReleaseMeta">
                <span className="whatsNewPopup--Version">v3.0</span>
                <span className="whatsNewPopup--Date">Juli 2026</span>
              </div>
              <h3 className="whatsNewPopup--ReleaseTitle">Neu in dieser Version</h3>
              <ul className="whatsNewPopup--ChangeList">
                <li>Scroll-Position bleibt erhalten: in der Produktübersicht und deren Konfigurations-Menü springt der Inhalt nach Socket-Updates oder Interaktionen (Produkt aufklappen, Optionen umschalten) nicht mehr an den Anfang zurück.</li>
                <li>Cloudwatch-/AWS-Tests öffnen jetzt – wie synthetische Tests – einen Performancegraph im Graph-Widget statt zum externen AWS-Dashboard zu verlinken; der Direktlink bleibt als Icon im Graph-Header verfügbar.</li>
                <li>Klare Herkunfts-Kennzeichnung im Graph: 3-Buchstaben-Tag (AWS/SYN) links neben Produkt- und Testname; für Cloudwatch-Alarme angepasste Achsenbeschriftung (OK/CRIT), Stufenlinie und &bdquo;Cloudwatch Status&ldquo;-Tooltip.</li>
                <li>Ausfälle in allen Performancegraphen (inkl. Fehleranalyse) deutlich sichtbar: Messwerte bei 0 Sekunden bekommen einen roten Marker, bei Cloudwatch-Alarmen zusätzlich einen roten Bodenstreifen; der Tooltip meldet &bdquo;Testlauf fehlgeschlagen&ldquo; statt irreführend &bdquo;Durchlaufzeit: 0 sek.&ldquo;.</li>
                <li>Detail-Widget für Cloudwatch-Alarme aufgeräumt (nur relevante Felder sichtbar, Klickweg- und Testhäufigkeits-Aktion deaktiviert) und Save-/Jira-Ticket-Dialoge im aktuellen Facelift-Stil.</li>
                <li>Komplett überarbeitetes Design mit neuer Farbwelt, moderner Typografie und aufgeräumtem Look-and-Feel.</li>
                <li>Neu gestaltete Widgets – u.&nbsp;a. Status-Kacheln, Downtime-Verwaltung und Synthetic-Monitoring-Analyse.</li>
                <li>Neuer Header mit Freenet-Blade-Logo und Versions-Kennzeichnung; Konfigurations-Slide-In modernisiert (inkl. Sonne/Mond-Theme-Umschalter).</li>
                <li>Alle Widget-Konfigurationsmenüs überarbeitet – gruppierte Optionen, Bulk-Aktionen und Counter für die Produktauswahl.</li>
                <li>Performance-Graphen mit dezenteren Gridlines und modernisierten Bedienelementen (Fehleranalyse, Ticket-Erstellung, Detail-Ansicht).</li>
                <li>Farbige Status-Labels für Jira-Tickets im Detail-Widget – Status auf einen Blick erkennbar.</li>
                <li>Fehleranalyse: 1-Klick-Export von Fehlerinformationen und Screenshot als JPG oder in die Zwischenablage.</li>
                <li>Jira-Tickets: deutlich schärfere Screenshots mit korrektem Seitenverhältnis; optimierte Eingabefelder im Dark-Mode.</li>
                <li>Log-, Klickweg- und Handlungsanweisung-Overlays im Detail-Widget im neuen Card-Look.</li>
                <li>TV Error only-Widget: Kacheln passen sich automatisch an Widget-Größe und Anzahl an – alle Alarme bleiben ohne Scrolling sichtbar (Monitorwand-tauglich).</li>
                <li>Vereinheitlichte Lade- und Interaktions-Indikatoren im gesamten Dashboard.</li>
                <li>Verlässlicheres Speichern individueller Dashboards inkl. Grafik-Konfigurationen.</li>
              </ul>
            </div>
          </div>

          <div className="whatsNewPopup--Actions">
            <button
              type="button"
              className="whatsNewPopup--BtnPrimary"
              onClick={() => closeWhatsNewWindow()}
            >
              Alles klar
            </button>
          </div>
        </div>
      </Popup> 
      
      <MainMenu 
        isShown={mainMenuStatus.shown} 
        handleHover={toggleMainMenuStatus}
        handleNotify={notify}
        handleToggleDowntime={toggleDowntime}
        handleAddNewWidget={addNewWidget}
        dashboardData={dashboardData}
        availableDashboards={availabledashboards}
        handleChangeShownDashboard={changeShownDashboard}
        handleDeleteDashboard={checkBeforeDashboardDelete}
        receiveIDToken={getIDToken}
        handleSwitchTheme={switchTheme}
        theme={theme}
      />

      <div className="mainWrap">
        <Popup open={showSaveModal} closeOnDocumentClick onClose={setShowSaveModal}>
            <div className="confirmModal">
                  <div className="confirmModalHeader">
                    <div className="confirmModalIcon" aria-hidden="true">
                      <FontAwesomeIcon icon="fa-solid fa-floppy-disk" />
                    </div>
                    <div className="confirmModalHeaderText">
                      <div className="confirmModalHeaderMeta">Dashboard sichern</div>
                      <div className="confirmModalHeaderTitle">Dashboard speichern</div>
                    </div>
                  </div>

                  <div className="confirmModalBody">
                    <label className="confirmModalLabel" htmlFor="save-dashboard-name">Name des Dashboards</label>
                    <input id="save-dashboard-name" className="confirmModalInput"
                      type="text"
                      name="name"
                      placeholder={shownDashboardName}
                      onChange={handleNewDashboardName}
                    />
                    <div className="confirmModalBodyHint">Ohne Eingabe wird das bestehende Dashboard „{shownDashboardName}" überschrieben.</div>
                  </div>

                  <div className="confirmModalActions">
                    <button
                      type="button"
                      className="confirmModalBtn confirmModalBtn--secondary"
                      onClick={() => {
                        setShowSaveModal(false)
                      }}
                    >
                      Abbrechen
                    </button>
                    <button
                      type="button"
                      className="confirmModalBtn confirmModalBtn--primary"
                      onClick={() => {
                        saveDashboard()
                      }}
                    >
                      Speichern
                    </button>
                  </div>
                </div>
        </Popup> 
        <Popup open={showDeleteModal} closeOnDocumentClick onClose={setShowDeleteModal}>
            <div className="confirmModal">
                  <div className="confirmModalHeader">
                    <div className="confirmModalIcon confirmModalIcon--danger" aria-hidden="true">
                      <FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" />
                    </div>
                    <div className="confirmModalHeaderText">
                      <div className="confirmModalHeaderMeta">Bestätigung erforderlich</div>
                      <div className="confirmModalHeaderTitle">Dashboard löschen</div>
                    </div>
                  </div>

                  <div className="confirmModalBody">
                    <div>Soll das Dashboard <strong>„{markedToBeDeleted.dashboardName}"</strong> wirklich gelöscht werden?</div>
                    <div className="confirmModalBodyHint">Diese Aktion kann nicht rückgängig gemacht werden.</div>
                  </div>

                  <div className="confirmModalActions">
                    <button
                      type="button"
                      className="confirmModalBtn confirmModalBtn--secondary"
                      onClick={() => {
                        setShowDeleteModal(false)
                      }}
                    >
                      Abbrechen
                    </button>
                    <button
                      type="button"
                      className="confirmModalBtn confirmModalBtn--danger"
                      onClick={() => {
                        deleteDashboard()
                      }}
                    >
                      Löschen
                    </button>
                  </div>
                </div>
        </Popup>  
        <Popup open={showUnsafedChangesModal} closeOnDocumentClick onClose={setShowUnsafedChangesModal}>
            <div className="confirmModal">
                  <div className="confirmModalHeader">
                    <div className="confirmModalIcon confirmModalIcon--danger" aria-hidden="true">
                      <FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" />
                    </div>
                    <div className="confirmModalHeaderText">
                      <div className="confirmModalHeaderMeta">Ungesicherte Änderungen</div>
                      <div className="confirmModalHeaderTitle">Änderungen verwerfen</div>
                    </div>
                  </div>

                  <div className="confirmModalBody">
                    <div>Am aktuellen Dashboard gibt es ungesicherte Änderungen. Sollen diese wirklich verworfen werden?</div>
                    <div className="confirmModalBodyHint">Nicht gespeicherte Anpassungen gehen dabei verloren.</div>
                  </div>

                  <div className="confirmModalActions">
                    <button
                      type="button"
                      className="confirmModalBtn confirmModalBtn--secondary"
                      onClick={() => {
                        setShowUnsafedChangesModal(false);
                      }}
                    >
                      Behalten
                    </button>
                    <button
                      type="button"
                      className="confirmModalBtn confirmModalBtn--danger"
                      onClick={() => {
                        changeShownDashboardOverride();
                      }}
                    >
                      Verwerfen
                    </button>
                  </div>
                </div>
        </Popup>                
        <Header 
          headerData={headerData} 
          isShown={mainMenuStatus.shown} 
          handleHover={toggleMainMenuStatus}
          handleWhatsNew={openWhatsNewWindow}
          userName={graphData ? graphData.displayName : ""}
          unsavedChanges={unsavedChanges}
          handleSaveDashboard={checkBeforeSaveDashboard}
          receiveIDToken={getIDToken}
        />

        <main className="contentWrap">
        {downtimeAdminVisible.shown ? <DowntimeAdmin 
                                  handleNotify = {notify}
                                  receiveIDToken={getIDToken}
                                  handleToggleDowntime={toggleDowntime}
                                  userName={graphData ? graphData.displayName : ""}
        /> : null}
        {synmonAnalyseVisible.shown ? <SynmonAnalyse 
                                  handleNotify = {notify}
                                  receiveIDToken={getIDToken}
                                  data = {synmonAnalyseVisible}
                                  handleToggleSynmonAnalyse={toggleSynmonAnalyse}
        /> : null}  

        
          {dashboardDataAvailable ? 
            <DashboardSystemWithHooks 
              key={childKey} 
              productData={productData}
              visibleGraphs={visibleGraphs}
              handleNotify={notify}
              handleAddWidget={addNewWidget}
              handleAddGraph={addGraph}
              handleAddAllGraphs={addAllGraphs}
              //handleDeleteWidget={deleteWidget}
              handleDeleteGraph={deleteSingleGraph}
              handleDeleteAllGraphs={deleteAllGraph}
              handleChangeGraphOptions={changeGraphOptions}
              handleGraphDefaultTimerange={graphDefaultTimerange}
              handleToggleSynmonAnalyse={toggleSynmonAnalyse}
              receiveIDToken={getIDToken}
              receiveAccessToken={refreshIDToken}

              shownDashboardID={shownDashboardID}
              activeWidgets={activeWidgets}
              dashboardCount={dashboardCount}
              userName={graphData ? graphData.displayName : ""}
              replaceGraph={replaceGraph}
              syncVisibleWidgets={syncVisibleWidgets}
              syncOptionsArray={syncOptionsArray}
              handleDeleteFromOptions={removeFromOptions}
              savedOptionsArray={savedOptionsArray}
              //dashboardWidgets={savedWidgetArray}
              addWidgetType={addWidgetType}
            /> : 
          <>
            <div className="dashLoading">
              {dashboardFatalError ? (
                <div className="dashLoading--Card dashLoading--Card--Error">
                  <div className="dashLoading--IconWrap dashLoading--IconWrap--Error">
                    <FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" />
                  </div>
                  <div className="dashLoading--Title">Dashboard nicht verfügbar</div>
                  <p className="dashLoading--Subtitle">
                    Die Dashboard-Daten konnten nicht geladen werden. Bitte lade
                    die Seite erneut. Wenn das Problem länger besteht, wende dich
                    an das Team&nbsp;Development&nbsp;&amp;&nbsp;Dashboards.
                  </p>
                </div>
              ) : (
                <div className="dashLoading--Card">
                  <img src={baseBlade} alt="" className="dashLoading--Logo" />
                  <div className="dashLoading--Title">Zentrales Monitoring Dashboard</div>
                  <p className="dashLoading--Subtitle">Dein Dashboard wird geladen …</p>
                  <div className="dashLoading--Spinner"><AppSpinner /></div>
                </div>
              )}
            </div>
          </>

        }

        </main>

      </div>
      </>
    </div>
  );
}

const AppWrap = () => {
  const authRequest = {
      ...loginRequest
  };

  return (
      <MsalAuthenticationTemplate 
          interactionType={InteractionType.Redirect} 
          authenticationRequest={authRequest} 
          //errorComponent={ErrorComponent} 
          //loadingComponent={Loading}
      >
          <App />
      </MsalAuthenticationTemplate>
    )
};

export default memo(AppWrap)

